import { Popover, POPOVER_HORIZONTAL, POPOVER_VERTICAL } from '@shared/ui/popover';
import { ChevronDownIcon, ChevronUpIcon } from '@shared/assets/icons';
import { EventStatistic, EVENT_STATISTICS } from '@entities/event';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';
import { useRef, useState } from 'react';
import { styles } from './styles';

interface EventStatisticsHeaderProps {
  typeStatistic: EventStatistic;
  setTypeStatistic: (value: EventStatistic) => void;
}

export const EventStatisticsHeader = ({ typeStatistic, setTypeStatistic }: EventStatisticsHeaderProps) => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [isOpenMenu, setIsOpenMenu] = useState(false);

  const onChangeTypeStatistic = (value: EventStatistic) => {
    setTypeStatistic(value);
    setIsOpenMenu(false);
  };

  return (
    <div {...stylex.props(styles.header)}>
      <span {...stylex.props(styles.title)}>Статистика</span>

      <UnstyledButton ref={anchorRef} onClick={() => setIsOpenMenu(true)}>
        <div {...stylex.props(styles.menuContainer)}>
          <span {...stylex.props(styles.menuTitle)}>{typeStatistic.name}</span>
          {isOpenMenu ? <ChevronUpIcon color={colors.accentText} /> : <ChevronDownIcon color={colors.accentText} />}
        </div>
      </UnstyledButton>

      <Popover
        anchorRef={anchorRef}
        anchorOrigin={{ horizontal: POPOVER_HORIZONTAL.RIGHT, vertical: POPOVER_VERTICAL.BOTTOM }}
        transformOrigin={{ horizontal: POPOVER_HORIZONTAL.RIGHT, vertical: POPOVER_VERTICAL.TOP }}
        open={isOpenMenu}
        onClose={() => setIsOpenMenu(false)}
        preventOverflow
      >
        <div {...stylex.props(styles.menu)}>
          {EVENT_STATISTICS.map((statistic) => (
            <UnstyledButton key={statistic.id} onClick={() => onChangeTypeStatistic(statistic)}>
              <span {...stylex.props(styles.menuItem, statistic.id === typeStatistic.id && styles.menuItemSelected)}>
                {statistic.name}
              </span>
            </UnstyledButton>
          ))}
        </div>
      </Popover>
    </div>
  );
};
